/* eslint-disable react/destructuring-assignment */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import DOM from './utilisationReport';

import * as eventsActions from '../../../../core/events/eventsActions';
import * as reportActions from '../../../../core/report/reportActions';
import * as assetActions from '../../../../core/asset/assetActions';

const { DB_DATE_FORMAT } = require('../../../../core/constants').default;

class UtilisationReport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: {},
            filterSidebar: true,
        };
        this.view = DOM;
    }

    componentDidMount() {
        const { actions, dataEventToReportParams } = this.props;
        actions.resetReportsRequest();
        if (dataEventToReportParams !== null) {
            const params = {
                ...dataEventToReportParams,
                page: 1,
            };
            actions.getUtilisationReportRequest(params);
            actions.setDataEventToReportParams(null);

            this.setState({ filters: params, filterSidebar: false });
        } else {
            this.onEventsTabFilterChange({
                date_from: moment().subtract(1, 'day'),
                date_to: moment(),
                target_hours: 8,
                asset_or_driver: 'assets',
                page: 1,
            });
        }
    }

    onEventsTabPageChange = (page, pageSize) => {
        const { actions } = this.props;
        const { filters } = this.state;
        filters.page = page;
        actions.getUtilisationReportRequest(filters);
    };

    onEventsTabSortChange = (pagination, x, sorter, extra) => {
        const { actions, utilisationReportPagination } = this.props;
        const { filters } = this.state;

        // checking when only order changes
        if (pagination && pagination.current.toString() === utilisationReportPagination.currentPage) {
            const params = { orderBy: `${sorter.order == 'descend' ? '-' : ''}${sorter.field}`, ...filters };
            actions.getUtilisationReportRequest(params);
        }
    };

    onEventsTabFilterChange = (values) => {
        const filters = values;
        if (filters.date_from) {
            filters.date_from = values.date_from.format(DB_DATE_FORMAT);
        }
        if (filters.date_to) {
            filters.date_to = values.date_to.format(DB_DATE_FORMAT);
        }
        if (filters.asset_id) {
            filters.asset_info = values.asset_id;
        }
        filters.page = 1;
        this.setState({ filters });
        const { actions } = this.props;
        const params = { ...filters };

        actions.getUtilisationReportRequest(params);
    };

    exportCsv() {
        const { filters } = this.state;

        if (filters.date_from) {
            filters.date_from = moment(filters.date_from).format(DB_DATE_FORMAT);
        }
        if (filters.date_to) {
            filters.date_to = moment(filters.date_to).format(DB_DATE_FORMAT);
        }

        filters.page = 1;
        filters.export = true;
        this.setState({ filters });
        const { actions } = this.props;
        const params = { ...filters };

        actions.getUtilisationReportRequest(params);
    }

    render() {
        return this.view(
            {
                update: (newVals) => (
                    this.props.actions.UpdateEventNotifications(newVals)
                ),
            },
        );
    }
}

UtilisationReport.propTypes = {
    actions: PropTypes.object.isRequired,
    utilisationReport: PropTypes.array.isRequired,
};

UtilisationReport.defaultProps = {
    utilisationReport: [],
    utilisationReportPagination: {
        currentPage: 1,
        totalRecords: 0,
        pageCount: 0,
        perPageCount: 10,
    },
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        utilisationReport: state.report.utilisationReport,
        utilisationReportPagination: state.report.utilisationReportPagination,
        events: state.events.companyEvents,
        user: state.user,
        filterSidebar: state.filterSidebar,
        dataEventToReportParams: state.global.dataEventToReportParams,
        isFetching: state.report.isFetching,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...eventsActions,
            ...reportActions,
            ...assetActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(UtilisationReport);
